import { getAuthToken } from ':fat/auth/tokenStore';

const DEFAULT_API_URL = 'https://api.commerce.coinbase.com';

export function getBaseUrl() {
  return process.env.COMMERCE_API_URL ?? DEFAULT_API_URL;
}

export function getAuthHeaders(): Record<string, string> {
  const token = getAuthToken();
  if (token) {
    return { 'X-FAT-Token': token };
  }
  return {};
}

export async function validateToken(): Promise<boolean> {
  try {
    const response = await fetch(`${getBaseUrl()}/v2/funds-access/btc/xpub/dummy/info`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
    });
    // 401 = invalid token, 5xx = server error — both redirect
    // 400/404 = bad dummy value but token is fine — proceed
    if (response.status === 401 || response.status >= 500) {
      return false;
    }
    return true;
  } catch {
    // Network errors are not auth failures — let the app proceed
    return true;
  }
}
